export default __webpack_public_path__ + "static/media/travelboard.61c75eef.jpg";